
import { NavLink } from "react-router-dom"
import { getRoutePath }  from "../../../utils";
export default function Navbar({
    topmenuList
})
{
    return (
        <ul className=" nav navbar-nav">
            {
                topmenuList && topmenuList?.length > 0 && topmenuList.map((item,index) => {
                    const children = item?.children;

                    if(children && children.length > 0 ) {
                        return (
                            <li className={index === 0 ? "active" : ""} key={`li-${index}`}>
                                <a href="#">{item?.title}<i className="fa fa-chevron-down" /></a>
                                <ul className="sub-menu">
                                    {
                                        children.map((child,ind) => {
                                            return (
                                                <li key={`child-${ind}`}>
                                                    <NavLink to={getRoutePath(child)}>
                                                        {child?.title}
                                                    </NavLink>
                                                </li>
                                            )
                                        })
                                    }
                                   
                                </ul>
                            </li>
                        )
                    }
                    
                    return <li className={index === 0 ? "active" : ""} key={`cli-${index}`}>
                                <NavLink to={getRoutePath(item)}>{item.title}</NavLink>
                            </li>
                })
            }
        </ul>    
    )
}